import React from 'react';
import HeroSection from '../../components/HomeLandingComp/HeroSectionComp/HeroSection';
import Product from '../../components/HomeLandingComp/ProductsComp/Product';
import AboutSection from '../../components/HomeLandingComp/AboutSectionComp/AboutSection';
import ContactForm from '../../components/HomeLandingComp/ContactFormComp/ContactForm';
import Footer from '../../components/HomeLandingComp/FooterComp/Footer'


const Layout = () => {
    return (
        <div>
            <HeroSection />
            <AboutSection />
            <Product />
            <ContactForm />
            <Footer />
        </div>
    )
}

export default Layout